import { useEffect } from "react";
import { FaEye, FaChevronRight } from "react-icons/fa6";
import { useReportContext } from "../../../../_context/ReportContext";
import { Area } from "../../../../_models/Report.model";

interface OffCanvasClientListProps {
  selectedAreaIndex: number;
  setSelectedAreaInex: React.Dispatch<React.SetStateAction<number>>;
}

export const OffCanvasClientList: React.FC<OffCanvasClientListProps> = ({
  selectedAreaIndex,
  setSelectedAreaInex,
}) => {
  const { newReport, viewedAreas, setViewedAreas } = useReportContext();

  const handleSelecedArea = (areaSelected: Area, areaIndex: number) => {
    setViewedAreas(new Set(viewedAreas).add(areaSelected.Name));
    setSelectedAreaInex(areaIndex);
  };

  // set the first area Eye icon always visible
  useEffect(() => {
    if (newReport.Areas.length > 0) {
      setViewedAreas((prevViewedAreas) => {
        const updatedViewedAreas = new Set(prevViewedAreas);
        updatedViewedAreas.add(newReport.Areas[0].Name);

        prevViewedAreas.forEach(areaName => {
          if (!newReport.Areas.find(area => area.Name === areaName)) {
            updatedViewedAreas.delete(areaName);
          }
        });
        return updatedViewedAreas;
      });
    }
  }, [newReport.Areas, setViewedAreas]);

  return (
    <div>
      <h3 style={{ fontSize: "1.05rem", fontWeight: 700, color: "#0f1c34", marginBottom: "16px", paddingLeft: "8px" }}>
        Inspection Areas
      </h3>
      <div className="rp-areas-nav">
        {newReport.Areas.map((area, index) => {
          const isSelected = newReport.Areas[selectedAreaIndex]?.Name === area.Name;
          const isViewed = viewedAreas.has(area.Name);

          return (
            <button
              key={`areaSelectButton_${index}`}
              className="rp-area-nav-btn"
              onClick={() => handleSelecedArea(area, index)}
              style={{
                background: isSelected ? "rgba(37,99,192,0.1)" : "transparent",
                color: isSelected ? "#2563C0" : "#4B5563",
                fontWeight: isSelected ? 700 : 600,
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.background = "rgba(0,0,0,0.03)";
                  e.currentTarget.style.color = "#0f1c34";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.background = "transparent";
                  e.currentTarget.style.color = "#4B5563";
                }
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "10px", width: "100%" }}>
                {/* Viewed Indicator */}
                <div style={{
                  width: "18px",
                  display: "flex",
                  justifyContent: "center",
                  color: isViewed ? "#16a34a" : "transparent"
                }}>
                  <FaEye size={14} />
                </div>

                <span style={{ flex: 1, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                  {area.Name}
                </span>

                {isSelected && (
                  <FaChevronRight size={12} style={{ color: "#2563C0" }} />
                )}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
